<template>
  <div class="economic-card">
    <img class="economic-card__image" alt="card_image" :src="imageUrl" />
    <div class="economic-card__meta">
      <div class="economic-card__title d-flex">
        <img :src="iconUrl" alt="icon_url" />
        <span>{{ title }}</span>
      </div>
      <div class="economic-card__impact">
        <span> {{ currencySymbol }} </span>
        <span>
          {{ economicImpact.toLocaleString(navigator.language) }}
        </span>
        <span> {{ currency }}</span>
      </div>
      <div v-if="!isSameCurrency" class="economic-card__exchange">
        <span> {{ organizationCurrencySymbol }} </span>
        <span>
          {{ exchange.toLocaleString(navigator.language) }}
        </span>
        <span> {{ exchangeCurrency }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EconomicImpactCard',

  props: {
    title: {
      type: String,
      required: true,
    },
    imageUrl: {
      type: String,
      required: true,
    },
    iconUrl: {
      type: String,
      required: true,
    },
    economicImpact: {
      type: Number,
      required: true,
    },
    currency: {
      type: String,
      required: true,
    },
    exchange: {
      type: Number,
      required: false,
    },
    exchangeCurrency: {
      type: String,
      required: true,
    },
    currencySymbol: {
      type: String,
      required: true,
    },
    organizationCurrencySymbol: {
      type: String,
      required: false,
    },
  },

  computed: {
    isSameCurrency() {
      return this.currency === this.exchangeCurrency
    },
  },
}
</script>

<style lang="scss" scoped>
.economic-card {
  box-shadow: 0px 1px 2px rgba(120, 135, 155, 0.3);
  border-radius: 4px;
  background: $color-white;
  display: flex;

  &__image {
    margin: 8px 8px 16px 16px;
  }

  &__meta {
    margin-top: 28px;
    margin-right: 24px;
  }

  &__title {
    color: $color-blue-grey-darken1;
    font-size: 12px;
    margin-bottom: 8px;

    img {
      margin-right: 8px;
    }
  }

  &__impact {
    color: $color-blue-grey-darken3;
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 4px;
  }

  &__exchange {
    color: $color-blue-grey-darken1;
    font-size: 12px;
  }
}
</style>
